// extracted by mini-css-extract-plugin
export var flexwrapper = "linestamp-module--flexwrapper--a6682";
export var leadsubscribetext = "linestamp-module--leadsubscribetext--129d6";
export var leadtext = "linestamp-module--leadtext--e637c";
export var lineadswrapper = "linestamp-module--lineadswrapper--22331";
export var linkimg = "linestamp-module--linkimg--bb05a";
export var linkwrapper = "linestamp-module--linkwrapper--d4e21";
export var otomodachilinkwrapper = "linestamp-module--otomodachilinkwrapper--212f5";
export var stamplinkwrapper = "linestamp-module--stamplinkwrapper--5fea5";
export var subscribewrapper = "linestamp-module--subscribewrapper--dc712";